import Swiper, { Autoplay, Navigation, Keyboard } from 'swiper'
import 'swiper/swiper-bundle.css'
import './styles.scss'

Swiper.use([ Autoplay, Navigation, Keyboard ])

const setProductSliders = () => {
    document.querySelectorAll('.products-slider').forEach((sliderContainer) => {
        if (sliderContainer.swiper) {
            sliderContainer.swiper.destroy()
        }

        const productSlider = new Swiper(sliderContainer, {
            direction: 'horizontal',

            autoplay: true,
            delay: 4000,

            slidesPerView: 4,

            loop : true,
            
            navigation: {
                nextEl: sliderContainer.querySelector('.swiper-button-next'),
                prevEl: sliderContainer.querySelector('.swiper-button-prev'),
            },

            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },

            on: {
                init() {
                    this.el.addEventListener('mouseenter', () => {
                        if (this && this.autoplay) {
                            this.autoplay.stop()
                        }
                    })

                    this.el.addEventListener('mouseleave', () => {
                        if (this && this.autoplay) {
                            this.autoplay.start()
                        }
                    })
                }
            },

            breakpointsBase : 'container',
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },

                620: {
                    slidesPerView: 2,
                },

                930: {
                    slidesPerView: 3,
                },

                1240: {
                    slidesPerView: 4,
                },
            }
        })
    })
},
resizeProductSliders = () => {
    document.querySelectorAll('.products-slider-outer').forEach((productSliderNode) => {
        productSliderNode.style.width = '0px'

        setTimeout(() => {
            productSliderNode.style.width = (document.querySelector('.inner').offsetWidth - 40) + 'px'

            setProductSliders()
        }, 0)
    })
}

resizeProductSliders()
window.addEventListener('resize', resizeProductSliders)

setTimeout(() => {
    setProductSliders()
}, 0)